import { render, staticRenderFns } from "./EditEmailAlertsPageTitle.vue?vue&type=template&id=6a56365a&"
import script from "./EditEmailAlertsPageTitle.vue?vue&type=script&lang=js&"
export * from "./EditEmailAlertsPageTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
